import React, { useState } from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import './TestLoanCreateModal.css'

const TestLoanCreateModalUI = ({ context, successMsg, errorList, setErrorList, loan,
  // modes
  createLoanMode, submitted,
  // event handlers
  onSubmit, onCancelCreateLoan,
  // form fields
  loanName, onLoanNameChange, loanNameError, setLoanNameError, loanNameList,
  status, onStatusChange, statusError, setStatusError, statusList,
  subStatus, onSubStatusChange, subStatusError, setSubStatusError, subStatusList,
  loanType, onLoanTypeChange, loanTypeError, setLoanTypeError, loanTypeList,
  loanSubType, onLoanSubTypeChange, loanSubTypeError, setLoanSubTypeError, loanSubTypeList,
  appFlavor, onAppFlavorChange, appFlavorError, setAppFlavorError, appFlavorList,
  onLoanTenureMonthsChange, loanTenureMonths, loanTenureMonthsError, setLoanTenureMonthsError,
  loanPurpose, onLoanPurposeChange, loanPurposeError, setLoanPurposeError, loanPurposeList, sectorList,
  loanAmountF, onLoanAmountFChange, loanAmountFError, setLoanAmountFError,
  tenureMonths, onTenureMonthsChange, tenureMonthsError, setTenureMonthsError,
  interestTenureMonths, onInterestTenureMonthsChange, interestTenureMonthsError, setInterestTenureMonthsError, showInterestTenureMonths,
  interestRate, onInterestRateChange, interestRateError, setInterestRateError,
  disbursementDate, onDisbursementDateChange, disbursementDateError, setDisbursementDateError, capex, onCapexChange,
}) => {
  const [showLoanTenure, setShowLoanTenure] = useState(false);
  const onShowLoanTenure = () => {
    setShowLoanTenure(prevShowLoanTenure => !prevShowLoanTenure);
  };
  return (
    <ModalFormUI
      context={context}
      titleLabel='Create loan'
      buttonLabel='Create loan'
      cancelLabel='Cancel'
      isOpen={createLoanMode}
      onRequestClose={onCancelCreateLoan}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div className='g_flex_h g_flex_top c_ln_crt'>
        <div className='col'>
          <InputTextSF type='text' name='s_name' required={true} maxLength={12}
            label='Loan name' autoFocus={true}
            value={loanName} onChange={onLoanNameChange}
            error={loanNameError} setError={setLoanNameError}
          />
          <InputSelectSF type='select' name='status' required={true} label='Status'
            value={status} optionList={statusList}
            onChange={onStatusChange} error={statusError} setError={setStatusError}
          />
          {
            status === 'disbursed' &&
            <span className='g_muted'>In this status, funds are not disbursed
              but repayment schedule and other data are created</span>
          }
          <InputSelectSF type='select' name='subStatus' required={true} label='Sub status'
            value={subStatus} optionList={subStatusList}
            onChange={onSubStatusChange} error={subStatusError} setError={setSubStatusError}
          />
          {
            subStatus === 'term_sheet_review' &&
            <span className='g_muted'>In this sub status, Termsheet is not created in Leegality
              but other data is created. To create Termsheet is not created in Leegality,
              update the term sheet in superuser console</span>
          }
          {
            subStatus === 'sanction_review' &&
            <span className='g_muted'>In this sub status, Sanction Letter is not created in Leegality
              but other data is created. To create Sanction Letter in Leegality,
              update the sanction in superuser console</span>
          }
          {
            status && status !== 'requested' &&
            <InputSelectSF type='select' name='loanType' required={true} label='Loan type'
              value={loanType} optionList={loanTypeList}
              onChange={onLoanTypeChange} error={loanTypeError} setError={setLoanTypeError}
            />
          }
          {
            status && status !== 'requested' && loanType === 'project' &&
            <InputSelectSF type='select' name='loanSubType' required={true} label='Loan sub type'
              value={loanSubType} optionList={loanSubTypeList}
              onChange={onLoanSubTypeChange} error={loanSubTypeError} setError={setLoanSubTypeError}
            />
          }
        </div>
        <div className='g_m_left_100 col'>
          <InputSelectSF type='select' name='appFlavor' required={true} label='App flavor'
            value={appFlavor} optionList={appFlavorList}
            onChange={onAppFlavorChange} error={appFlavorError} setError={setAppFlavorError}
          />

          {/* </div> */}

          {/* <div className='g_m_left_100'> */}
          <InputTextSF type='text' name='s_amt' required={true} maxLength={12}
            label='Loan amount (₹)'
            value={loanAmountF} onChange={onLoanAmountFChange}
            error={loanAmountFError} setError={setLoanAmountFError}
          />
          <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
            label='Amortized/Interest tenure'
            value={tenureMonths} onChange={onTenureMonthsChange}
            error={tenureMonthsError} setError={setTenureMonthsError}
          />
          {(loanType === 'project' || loanType === 'int_then_prj') && (
            <>
              <InputCheckBoxUI
                label='Loan tenure months shorter than amortized months'
                onChange={onShowLoanTenure}
                checked={showLoanTenure}
                name='showLoanTenure'
              />
              {showLoanTenure && (
                <InputTextSF
                  type='text'
                  name='s_tnr'
                  maxLength={3}
                  label='Loan tenure (months)'
                  value={loanTenureMonths}
                  onChange={onLoanTenureMonthsChange}
                  error={loanTenureMonthsError}
                  setError={setLoanTenureMonthsError}
                />
              )}
            </>
          )}
          {
            showInterestTenureMonths &&
            <InputTextSF type='text' name='s_tnr' required={true} maxLength={2}
              label='Interest only tenure (months)'
              value={interestTenureMonths} onChange={onInterestTenureMonthsChange}
              error={interestTenureMonthsError} setError={setInterestTenureMonthsError}
            />
          }
        </div>
        <div className='g_m_left_100 col'>
          <InputTextSF type='text' name='s_intr' required={true} maxLength={8}
            label='Interest rate p.a.'
            value={interestRate} onChange={onInterestRateChange}
            error={interestRateError} setError={setInterestRateError}
          />
          <InputDateUI context={context} name='s_dDate'
            label='Disbursement date'
            selectedDateISO={disbursementDate} onChange={onDisbursementDateChange}
            error={disbursementDateError} setError={setDisbursementDateError}
          />
          <InputSelectSF type='select' name='loanPurpose' required={true} label='Loan purpose'
            value={loanPurpose} optionList={sectorList}
            onChange={onLoanPurposeChange} error={loanPurposeError} setError={setLoanPurposeError}
          />
          <InputCheckBoxUI label='Capital expenditure'
            onChange={onCapexChange} checked={capex}
            name='capex'
          />
        </div>
      </div>
      {/* </div> */}
    </ModalFormUI>
  )
}

export default TestLoanCreateModalUI
